import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { format } from 'date-fns'
import { ArticleLarge, SpinnerCard } from '../common/Layout'
import {
  loadOrderStart,
  loadOrderByIdStart
} from '../../redux/modules/orderDetail'
import { loadReasonsByOrder, submitTicket } from '../../redux/modules/ticket'
import { updateModalStart } from '../../redux/modules/profile'
import {
  loadFavoriteStart,
  deleteFavoriteStart,
  addFavoriteStart
} from '../../redux/modules/favorite'
import { loadMenuStart } from '../../redux/modules/order'
import { loadDeliveryDropoffStart } from '../../redux/modules/delivery'
import { closeAutoFavorite } from '../../redux/modules/checkout'
import { checkPiggybankStatusStart } from '../../redux/modules/featureToggles'
import { OrderSummary, OrderDetails } from '../common/OrderSummary'
import ConfirmationLocation from './ConfirmationLocation'
import FirstOrderModal from './FirstOrder'
import AutoFavoriteModal from './AutoFavorite'
import ContactUsSidebar from '../contact-us/ContactUsSidebar'
import { LocationOrderStatus } from '../common/Location'
import PiggyBank from '../community/PiggyBank'
import FriendsPanel from '../community/FriendsPanel'
import {
  loadFriendsStart,
  getFriendsOrdersStart
} from '../../redux/modules/friends'
import { SimpleSpinner } from '../common/SimpleSpinner'
import { uniqBy, flatten } from 'lodash'

const OrderStatus = ({ order }) => {
  return (
    <h1 className="row center-xs">
      <LocationOrderStatus
        extraClasses={{ confirm: true }}
        isConfirmation
        locationStatusClasses="order-status"
        order={order}
        statusText={
          !order.isPastCutoff && order.statusText !== 'Order Cancelled'
            ? 'Thank you for your order!'
            : order.statusText
        }
      />
    </h1>
  )
}

class Confirmation extends Component {
  constructor(props) {
    super(props)
    let {
      match: {
        params: { orderId, locationId }
      },
      loadOrderByIdStart,
      loadReasonsByOrder,
      loadFriendsStart,
      checkPiggybankStatusStart
    } = this.props
    loadOrderByIdStart(orderId)
    loadReasonsByOrder(orderId)
    loadFriendsStart()
    checkPiggybankStatusStart(locationId)
    let timer = setInterval(() => loadOrderByIdStart(orderId), 600000)
    this.state = { timer, showOrderSummary: false }
  }

  componentDidUpdate(prevProps) {
    let {
      match: {
        params: { locationId }
      },
      order,
      getFriendsOrdersStart,
      loadMenuStart,
      loadDeliveryDropoffStart,
      loadFavoriteStart,
      loadOrderStart
    } = this.props
    if (
      (!prevProps.order && order) ||
      (order && order.orderId !== prevProps.order.orderId)
    ) {
      getFriendsOrdersStart(format(order.orderDate, 'YYYY-MM-DD'), locationId)
      loadOrderStart(format(order.orderDate, 'YYYYMMDD'), locationId)
      loadMenuStart(order.deliveryDropoffId)
      loadDeliveryDropoffStart(order.deliveryDropoffId)
      loadFavoriteStart()
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.timer)
  }

  toggleShowOrderSummary = () => {
    this.setState({ showOrderSummary: !this.state.showOrderSummary })
  }

  render() {
    const {
      order,
      orders,
      loading,
      profile,
      updatingModal,
      updateModalStart,
      favorites,
      addFavoriteStart,
      deleteFavoriteStart,
      favoriteInfo,
      autoFavorite,
      isLoadingFavorites,
      closeAutoFavorite,
      submitting,
      reasons,
      submitTicket,
      friends,
      friendNotOrdered,
      isLoadingFriendsOrders,
      friendsOrderCount,
      isCheckingStatus,
      piggybankStatus,
      match: {
        params: { locationId }
      }
    } = this.props

    let autoFavorites = []
    order &&
      favoriteInfo &&
      favoriteInfo.forEach(info => {
        autoFavorites = autoFavorites.concat(
          order.orderItems.filter(item => item.menuItemId === info.menuItemId)
        )
      })
    return (
      <ConfirmationComponent
        order={order}
        loading={loading}
        profile={profile}
        favorites={favorites}
        submitting={submitting}
        autoFavorites={autoFavorites}
        updatingModal={updatingModal}
        isLoadingFavorites={isLoadingFavorites}
        closeAutoFavorite={closeAutoFavorite}
        autoFavorite={autoFavorite}
        updateModalStart={updateModalStart}
        addFavoriteStart={addFavoriteStart}
        deleteFavoriteStart={deleteFavoriteStart}
        reasons={reasons}
        submitTicket={submitTicket}
        friends={friends}
        friendNotOrdered={friendNotOrdered}
        isLoadingFriendsOrders={isLoadingFriendsOrders}
        friendsOrderCount={friendsOrderCount}
        orders={orders}
        isCheckingStatus={isCheckingStatus}
        piggybankStatus={piggybankStatus}
        locationId={locationId}
        showOrderSummary={this.state.showOrderSummary}
        toggleShowOrderSummary={this.toggleShowOrderSummary}
      />
    )
  }
}

export const ConfirmationComponent = ({
  order,
  loading,
  profile,
  updatingModal,
  updateModalStart,
  favorites,
  addFavoriteStart,
  deleteFavoriteStart,
  closeAutoFavorite,
  autoFavorites,
  isLoadingFavorites,
  submitting,
  reasons,
  submitTicket,
  friends,
  friendNotOrdered,
  isLoadingFriendsOrders,
  friendsOrderCount,
  orders,
  isCheckingStatus,
  piggybankStatus,
  locationId,
  showOrderSummary,
  toggleShowOrderSummary
}) => (
  <ArticleLarge>
    <SpinnerCard
      spinnerActive={!order || !friends || isCheckingStatus || loading}
    >
      <OrderStatus order={order} />
      {piggybankStatus &&
        (isLoadingFriendsOrders ? (
          <SimpleSpinner />
        ) : (
          <Fragment>
            <hr />
            <PiggyBank
              {...{
                friends,
                friendsOrderCount:
                  friendsOrderCount &&
                  uniqBy(
                    friendsOrderCount.reduce(
                      (ordered, i) => ordered.concat(i),
                      []
                    ),
                    'userId'
                  ),
                orders,
                locationId,
                activeOrders:
                  orders &&
                  orders.filter(order => order.orderState !== 'CANCELED')
              }}
              hideOrderStatus
              titleText={
                orders &&
                friendsOrderCount &&
                orders.filter(order => order.orderState !== 'CANCELED')
                  .length >= 1 &&
                flatten(friendsOrderCount).length >= 5
                  ? 'Earn Credit Daily'
                  : 'Want To Earn $1.00?'
              }
            />
            <FriendsPanel
              friends={friends}
              friendNotOrdered={friendNotOrdered}
            />
          </Fragment>
        ))}
    </SpinnerCard>
    <div className="row">
      <div className="col-xs-12 col-md-8">
        <SpinnerCard
          spinnerActive={loading || isLoadingFavorites || submitting}
        >
          <ConfirmationLocation
            order={order}
            showOrderSummary={showOrderSummary}
            toggleShowOrderSummary={toggleShowOrderSummary}
          />
          {showOrderSummary && (
            <OrderSummary>
              {order && (
                <OrderDetails
                  order={order}
                  favorites={favorites}
                  addFavoriteStart={addFavoriteStart}
                  deleteFavoriteStart={deleteFavoriteStart}
                />
              )}
            </OrderSummary>
          )}
          {autoFavorites.length >= 1 && (
            <AutoFavoriteModal
              closeAutoFavorite={closeAutoFavorite}
              items={autoFavorites}
            />
          )}
          {profile &&
            !profile.hidePostOrderModal &&
            (!order ||
              (order && order.statusText.indexOf('Cancelled') === -1)) && (
              <FirstOrderModal
                email={profile.username}
                updatingModal={updatingModal}
                updateModalStart={updateModalStart}
                showModal={profile.hidePostOrderModal}
              />
            )}
        </SpinnerCard>
      </div>
      <aside className="col-xs-12 col-md-4 confirmation-contact-us">
        <ContactUsSidebar
          className="contact-us-form"
          locationId={locationId}
          orderHistorySize
          order={order}
          showForm
          submitticket={submitTicket}
          reasons={reasons}
        />
      </aside>
    </div>
  </ArticleLarge>
)

const mapStateToProps = state => {
  const { order, orders, loading } = state.orderDetail
  const { profile, updatingModal } = state.profile
  const { favorites, isLoadingFavorites } = state.favorite
  const { favoriteInfo } = state.checkout
  const { submitting } = state.ticket
  const { reasons } = state
  const {
    friends,
    friendNotOrdered,
    isLoadingFriendsOrders,
    friendsOrderCount,
    isLoadingFriends
  } = state.friends
  const { isCheckingStatus, piggybankStatus } = state.featureToggles

  return {
    order,
    orders,
    loading,
    profile,
    updatingModal,
    favorites,
    favoriteInfo,
    isLoadingFavorites,
    submitting,
    reasons,
    friends,
    friendNotOrdered,
    isLoadingFriendsOrders,
    friendsOrderCount,
    isLoadingFriends,
    isCheckingStatus,
    piggybankStatus
  }
}

const mapDispatchToProps = {
  loadOrderByIdStart,
  loadReasonsByOrder,
  updateModalStart,
  loadFavoriteStart,
  loadMenuStart,
  loadDeliveryDropoffStart,
  deleteFavoriteStart,
  addFavoriteStart,
  closeAutoFavorite,
  submitTicket,
  loadFriendsStart,
  getFriendsOrdersStart,
  loadOrderStart,
  checkPiggybankStatusStart
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Confirmation)
